import { Component, OnInit, Input, EventEmitter } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
} from "@angular/forms";
import { AlertController, ModalController } from "@ionic/angular";
import { IStore, StoreService } from "src/app/store/services/store.service";
import {
  IPartialAddress,
  IAddress,
  AddressService,
} from "../../services/address.service";
import { finalize } from "rxjs/operators";
import { LoaderService } from "../../services/loader.service";
import { AlertService } from "../../services/alert.service";
//import { TranslateService } from "@ngx-translate/core";
import { SettingService } from "../../services/setting.service";
import { TranslationService } from "../../services/translation.service";

@Component({
    selector: "shared-address-editor-desktop-modal",
    templateUrl: "./address-editor-desktop-modal.component.html",
    styleUrls: ["./address-editor-desktop-modal.component.scss"],
    standalone: false
})
export class AddressEditorDesktopModalComponent implements OnInit {
  @Input() title: string = "";
  @Input() skipProvinceValidation: boolean;
  @Input() isReservation: boolean;
  @Input() postalCode: string;
  partialAddresses: IPartialAddress[] = [];
  store: IStore;

  constructor(
    //private translateService: TranslateService,
    private settingService: SettingService,
    private modalCtrl: ModalController,
    private addressService: AddressService,
    private loaderService: LoaderService,
    private storeService: StoreService,
    private alertCtrl: AlertController,
    private alertService: AlertService,
    private translationService: TranslationService
  ) {}

  ngOnInit() {
    if (this.isReservation) {
      this.storeService
        .getStore(localStorage.getItem("ReservationStoreId"))
        .subscribe((store) => {
          this.store = store;
          this.searchAddresses(this.postalCode);    //having the searchAddress outside makes it execute before we have the store and bug some validation based on the store address
        });
    } else {
      this.storeService
        .getStore(localStorage.getItem("StoreId"))
        .subscribe((store) => {
          this.store = store;
          this.searchAddresses(this.postalCode); //having the searchAddress outside makes it execute before we have the store and bug some validation based on the store address
        });
    }
    
  }

  onPostalCodeValidated(partialAddresses: IPartialAddress[]) {
    this.partialAddresses = partialAddresses;
  }

  cancel() {
    this.modalCtrl.dismiss(null);
  }

  onAddressValidate(address: IAddress) {
    this.modalCtrl.dismiss(address);
  }

  async searchAddresses(postalCode) {
    const loader = await this.loaderService.create();

    this.addressService
      .findByPostalCode(postalCode)
      .pipe(
        finalize(async () => {
          await loader.dismiss();
        })
      )
      .subscribe((result: IPartialAddress[]) => {
        result.map((value) => {
          value.postalCode = postalCode;
        });
        let addressValid = 1;

        if (result.length == 0) {
          this.alertService.showTranslate("Address.InvalidPostalCode");
        }
        if (!this.skipProvinceValidation) {
          if (this.store.address.province != result[0].provinceCode) {
            //Store level logic

            if (this.store.allowedProvince != null) {
              if (!this.store.allowedProvince.allowOtherProvince) {
                this.alertNoDelivery();
                return;
              } else {
                addressValid =
                  this.store.allowedProvince.allowedProvinces.findIndex(
                    (province) => province == result[0].provinceCode
                  );
                if (addressValid < 0) {
                  this.alertNoDelivery();
                  return;
                }
              }
            }
            //Merchant logic
            else {
              if (this.settingService.configuration.allowedProvince != null) {
                if (
                  !this.settingService.configuration.allowedProvince
                    .allowOtherProvince
                ) {
                  this.alertNoDelivery();
                  return;
                } else {
                  addressValid =
                    this.settingService.configuration.allowedProvince.allowedProvinces.findIndex(
                      (province) => province == result[0].provinceCode
                    );
                  if (addressValid < 0) {
                    this.alertNoDelivery();
                    return;
                  }
                }
              }
            }
          }
        }
        var uniqueAddresses= []
        var resp  = result.filter(obj =>{
          const addressKey = `${obj.provinceCode}-${obj.streetTypeCode}-${obj.city}-${obj.streetName}-${obj.postalCode}`;
          if (!uniqueAddresses[addressKey]) {
            uniqueAddresses[addressKey] = true;
            return true;
          }
          return false;
        })
        this.partialAddresses = resp;
      });
  }

  alertNoDelivery() {
    this.alertCtrl
      .create({
        header: this.translationService.translate(
          "Checkout.WrongPostalCodeHeading"
        ),
        message: this.translationService.translate("Checkout.WrongPostalCode"),
        buttons: [
          {
            text: "Okay",
            role: "cancel",
            cssClass: "secondary",
            handler: () => {},
          },
        ],
      })
      .then((al) => {
        al.present();
      });
  }
}
